import { render } from "./SeatmapParent.vue?vue&type=template&id=22bc9d15&scoped=true"
import script from "./SeatmapParent.vue?vue&type=script&lang=js"
export * from "./SeatmapParent.vue?vue&type=script&lang=js"

import "./SeatmapParent.vue?vue&type=style&index=0&id=22bc9d15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bc9d15"]])

export default __exports__